import Dialog from "./dialog/main";
import Pagination from "./Pagination.vue";
import Vue from "vue";
Vue.prototype.$dialog = Dialog;
Vue.component("pagination", Vue.extend(Pagination));
